import * as React from "react";
import Box from "@mui/material/Box";

import styled from "styled-components";
import {
  IconButton,
  Paper,
  Tooltip,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  Modal,
  ListItemButton,
  ListItemIcon,
  Toolbar,
} from "@mui/material";
import RSS from "../assets/rosoftsavvy.png";
import HomeIcon from "@mui/icons-material/Home";
import Drawer from "@mui/material/Drawer";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";
import CircleIcon from "@mui/icons-material/Circle";
import EditLocationIcon from "@mui/icons-material/EditLocation";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import "./style.css";
import { updateUser } from "../actions/user";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

export default function Header() {
  const drawerWidth = 160;
  const user = JSON.parse(secureLocalStorage.getItem("profile"));

  const [ModalOpen, setModalOpen] = React.useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logout = () => {
    dispatch(updateUser(user?.results._id, { login: "no", system: "none" }));
    setTimeout(() => {
      dispatch({ type: "LOGOUT" });
      navigate("/advice/login");
    }, 2000);
  };
  const handleOpen = () => {
    setModalOpen(true);
  };
  const handleClose = () => {
    setModalOpen(false);
  };

  let allowApprove = false;

  if (
    user?.results.e_advice === "Administrator" ||
    user?.results.e_advice === "Approver"
  ) {
    allowApprove = true;
  } else {
    allowApprove = false;
  }

  const list = allowApprove
    ? [
        {
          text: "Home",
          to: "/advice",
          icon: <HomeIcon />,
        },
        {
          text: "Locations",
          to: "/advice/locations",
          icon: <EditLocationIcon />,
        },
        {
          text: "Prepare Advice",
          to: "/advice/prepare-new-advice",
          icon: <AssessmentIcon />,
        },
        {
          text: "Report",
          to: "/advice/report",
          icon: <AssessmentIcon />,
        },
        {
          text: "Approvals",
          to: "/advice/approval",
          icon: <CheckIcon />,
        },
        {
          text: "Settings",
          to: "/advice/user-page",
          icon: <SettingsIcon />,
        },
      ]
    : [
        {
          text: "Home",
          to: "/advice",
          icon: <HomeIcon />,
        },
        {
          text: "Prepare Advice",
          to: "/advice/prepare-new-advice",
          icon: <AssessmentIcon />,
        },
        {
          text: "Report",
          to: "/advice/report",
          icon: <AssessmentIcon />,
        },
        {
          text: "Settings",
          to: "/advice/user-page",
          icon: <SettingsIcon />,
        },
      ];
  const location = useLocation();
  const path = location.pathname;

  const StyleSidebar = styled.aside`
    overflow: auto;
    grid-row: 1/-1;
    gap: 3.2rem;
  `;

  return (
    <StyleSidebar>
      <Modal
        open={ModalOpen}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'>
        <Box
          sx={style}
          style={{ backgroundColor: "#dfdfdf" }}
          className='animate__animated animate__pulse'>
          <Typography id='modal-modal-title' variant='h6' component='h2'>
            Logout Confirmation
          </Typography>
          <Typography style={{ marginTop: "10px", fontWeight: "bold" }}>
            {user?.results.firstName + " " + user?.results.lastName}
          </Typography>
          <Typography
            id='modal-modal-description'
            sx={{ mt: 2, marginBottom: "20px" }}>
            Are You Sure You Want To Exit?
          </Typography>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}>
            <Button
              style={{ backgroundColor: "#011B39" }}
              onClick={logout}
              size='small'
              variant='contained'>
              Yes <CheckIcon />
            </Button>
            <Button
              color='error'
              className='btn-danger'
              size='small'
              onClick={handleClose}
              variant='contained'>
              CANCEL <CancelIcon />
            </Button>
          </div>
        </Box>
      </Modal>

      <Drawer
        className='drawer-asset'
        sx={{
          width: drawerWidth,
          // marginTop: "1000px",
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            backgroundColor: "#21313c",
            color: "#F3F3F4",
            width: drawerWidth,
            height: "100vh",
            boxSizing: "border-box",
            // fontWeight: "bold",
            // borderRight: "1px solid grey",
            marginRight: "10px",
          },
        }}
        variant='permanent'
        elevation={0}
        anchor='left'>
        <Toolbar
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <img
            src={RSS}
            alt='Nyankomasi-Ahenkuro Rural Bank PLC logo'
            width={30}
            height={"auto"}
          />
        </Toolbar>
        <List>
          {list.map((text) => (
            <ListItem
              className={path === text.to ? "selected-item" : "unselected-item"}
              key={text.text}
              disablePadding>
              <ListItemButton onClick={() => navigate(text.to)}>
                <ListItemIcon
                  style={{
                    color: path === text.to ? "#000000" : "#fff",
                  }}>
                  {text.icon}
                </ListItemIcon>

                <ListItemText
                  style={{ marginLeft: "-25px", fontSize: "12px" }}
                  onClick={() => navigate(text.to)}>
                  <Typography style={{ fontSize: "12px" }}>
                    {text.text}
                  </Typography>
                </ListItemText>
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Paper
          style={{
            width: "90%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "5px",
            backgroundColor: "#cccc",
            border: "1px solid #F5AF14",
          }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Typography style={{ fontSize: "14px" }}>
              {user?.results.firstName + " " + user?.results.lastName}
            </Typography>
            <Typography
              style={{
                fontSize: "12px",
                marginLeft: "35%",
                // marginRight: "15%",
                backgroundColor: "#ffff",
                border: "1.5px solid #F5AF14",
                borderRadius: "5px",
                padding: "2px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}>
              <strong>Role:</strong> {user?.results.userRole}
              <CircleIcon
                className='blinking-text'
                style={{
                  fontSize: "10px",
                  color:
                    user?.results.userRole === "admin" ? "green" : "lightgreen",
                }}
              />
            </Typography>
          </div>
        </Paper>

        <Typography
          style={{
            marginTop: "20px",
            display: "flex",
            alignItems: "center",
            paddingLeft: "5px",
          }}>
          <HomeIcon /> Branch: {user?.results.branch}
        </Typography>

        <Tooltip title='click to logout'>
          <IconButton onClick={handleOpen} style={{ marginTop: "20px" }}>
            <LogoutIcon style={{ color: "#fff" }} />
          </IconButton>
        </Tooltip>
      </Drawer>
    </StyleSidebar>
  );
}
